import * as React from 'react';
import { Button, Form, Header, GridRow, Segment } from 'semantic-ui-react';

import configs from '../helpers/config';
import "../helpers/styles.css";
import { showMessage, validaEmail } from '../helpers/helper';
import recuperacaoService from '../services/recuperacao.service';

class SolicitarSenha extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            celular: '',
            status: 0,
            codigo: '',
            tempoReenvio: 0,
            nome: '',
            nascimento: '',
            senha: '',
            confirmarSenha: ''
        };
    }

    timerReenvio = () => {
        if (this.state.tempoReenvio > 0) {
            setTimeout(() => {
                this.setState({ tempoReenvio: this.state.tempoReenvio - 1 }, this.timerReenvio);
            }, 1000);
        }
    }

    handleEnviarSms = () => {
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(configs.RECAPTCHA_SITE_KEY, { action: 'PortalResultadosSolicitarSenhaSMS_1' }).then(async token => {
                const { celular } = this.state;
                const { success, mensagem, tempoReenvio } = await recuperacaoService.solicitarTokenAsync({
                    token,
                    celular
                });

                if (success) {
                    this.setState({ status: 1, tempoReenvio }, this.timerReenvio);
                } else {
                    showMessage(mensagem);
                }
            });
        });
    }

    handleValidarCodigo = () => {
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(configs.RECAPTCHA_SITE_KEY, { action: 'PortalResultadosSolicitarSenhaSMS_2' }).then(async token => {
                const { celular, codigo } = this.state;
                const { success, mensagem } = await recuperacaoService.validarTokenAsync({
                    token,
                    celular,
                    codigo
                });

                if (success) {
                    this.setState({ status: 2 });
                } else {
                    showMessage(mensagem);
                }
            });
        });
    }

    handleValidarCodigoPaciente = () => {
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(configs.RECAPTCHA_SITE_KEY, { action: 'PortalResultadosSolicitarSenhaSMS_3' }).then(async token => {
                const { celular, codigo, nome, nascimento } = this.state;
                const { success, mensagem } = await recuperacaoService.validarTokenPacienteAsync({
                    token,
                    celular,
                    codigo,
                    nome,
                    nascimento
                });

                if (success) {
                    this.setState({ status: 3 });
                } else {
                    showMessage(mensagem);
                    this.setState({
                        status: 0,
                        celular: '',
                        codigo: '',
                        nome: '',
                        nascimento: ''
                    }, this.props.onCancel);
                }
            });
        });
    }

    handleAlterarSenha = () => {
        const { celular, codigo, nome, nascimento, senha, confirmarSenha } = this.state;

        if (senha.length > 3 && senha === confirmarSenha) {
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(configs.RECAPTCHA_SITE_KEY, { action: 'PortalResultadosSolicitarSenhaSMS_4' }).then(async token => {
                    const { success, mensagem } = await recuperacaoService.alterarSenhaTokenAsync({
                        token,
                        celular,
                        codigo,
                        nome,
                        nascimento,
                        senha
                    });

                    if (success) {
                        showMessage('Senha alterada com sucesso!');
                    } else {
                        showMessage(mensagem);
                    }

                    this.setState({
                        status: 0,
                        celular: '',
                        codigo: '',
                        nome: '',
                        nascimento: '',
                        senha: '',
                        confirmarSenha: ''
                    }, this.props.onCancel);
                });
            });
        }
    }

    handleLogin() {
        const { email, celular, status } = this.state;
        if (!!email) {
            if (validaEmail(email)) {
                window.grecaptcha.ready(() => {
                    window.grecaptcha.execute(configs.RECAPTCHA_SITE_KEY, { action: 'PortalResultadosSolicitarSenha' }).then(token => {
                        this.setState({ recaptcha_token: token }, () => {
                            this.props.onClick({ ...this.state });
                        });
                    });
                });
            } else {
                showMessage('Email informado é inválido');
            }
        } else if (!!celular && this.props.tipo === 0) {
            const regexCelular = /\d{11}/;
            if (regexCelular.test(celular)) {
                switch (status) {
                    case 0:
                        this.handleEnviarSms();
                        break;
                    case 1:
                        this.handleValidarCodigo();
                        break;
                    case 2:
                        this.handleValidarCodigoPaciente();
                        break;
                    case 3:
                        this.handleAlterarSenha();
                        break;
                    default:
                        break;
                }
            } else {
                showMessage('Número do celular informado é inválido');
            }
        }
    }

    render() {
        return (
            <Segment className={this.props.className}>

                <Header as='h2'>
                    <p className='headerLogin'>{this.state.status >= 3 ? 'Informe a nova senha' : 'Recuperar senha'}</p>
                </Header>

                <Form size='large'>
                    <GridRow >
                        {this.state.status === 0 ?
                            <>
                                <Form.Input
                                    fluid
                                    icon='at'
                                    iconPosition='left'
                                    placeholder='Email'
                                    value={this.state.email}
                                    onChange={(e) => this.setState({ email: e.target.value })}
                                    disabled={this.props.tipo === 0 && !!this.state.celular}
                                />
                                {this.props.tipo === 0 &&
                                    <>
                                        <p>OU</p>
                                        <Form.Input
                                            fluid
                                            icon='mobile alternate'
                                            iconPosition='left'
                                            placeholder='DDD + Número Celular'
                                            value={this.state.celular}
                                            onChange={(e) => this.setState({ celular: e.target.value })}
                                            disabled={!!this.state.email}
                                        />
                                    </>}
                            </> : this.state.status === 1 ?
                                <>
                                    <Form.Input
                                        fluid
                                        icon='lock'
                                        iconPosition='left'
                                        placeholder='Informe o token recebido por SMS'
                                        value={this.state.codigo}
                                        onChange={(e) => this.setState({ codigo: e.target.value })}
                                    />
                                    <div style={{ display: 'flex', marginBottom: 10, justifyContent: 'space-between' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', paddingLeft: 5 }}>
                                            {`Celular: ${this.state.celular.replace(/\d{2}(\d)\d{4}(\d{4})/, '(xx) $1xxxx-$2')}`}
                                        </div>
                                        <div>
                                            <Button size='small' onClick={() => this.setState({ status: 0 })}>
                                                Alterar número
                                            </Button>
                                            <Button size='small' onClick={this.handleEnviarSms} disabled={!!this.state.tempoReenvio}>
                                                Reenviar {!!this.state.tempoReenvio ? `(${this.state.tempoReenvio})` : ''}
                                            </Button>
                                        </div>
                                    </div>
                                </> : this.state.status === 2 ?
                                    <>
                                        <Form.Input
                                            fluid
                                            icon='user outline'
                                            iconPosition='left'
                                            placeholder='Primeiro nome'
                                            value={this.state.nome}
                                            onChange={(e) => this.setState({ nome: e.target.value.trim() })}
                                        />
                                        <Form.Input
                                            fluid
                                            icon='calendar alternate outline'
                                            iconPosition='left'
                                            placeholder='Data de nascimento'
                                            value={this.state.nascimento}
                                            onChange={(e) => this.setState({
                                                nascimento: e.target.value
                                                    .replace(/\D+/g, "")
                                                    .substr(0, 8)
                                                    .replace(/(\d{2})(\d{2})(\d{4})/, "$1/$2/$3")
                                            })}
                                        />
                                    </> :
                                    <>
                                        <Form.Input
                                            fluid
                                            type='password'
                                            placeholder='Nova senha'
                                            value={this.state.senha}
                                            onChange={(e) => this.setState({ senha: e.target.value })}
                                        />
                                        <Form.Input
                                            fluid
                                            type='password'
                                            placeholder='confirmar senha'
                                            value={this.state.confirmarSenha}
                                            onChange={(e) => this.setState({ confirmarSenha: e.target.value })}
                                        />
                                    </>
                        }
                        <Button fluid size='large' onClick={() => this.handleLogin()}>
                            {this.state.status >= 3 ? 'Alterar' : 'Recuperar'}
                        </Button >
                    </GridRow>
                </Form>
            </Segment>);
    }
}

export default SolicitarSenha;
